import { render, staticRenderFns } from "./barcode.vue?vue&type=template&id=96bc6fda&scoped=true&"
import script from "./barcode.vue?vue&type=script&lang=js&"
export * from "./barcode.vue?vue&type=script&lang=js&"
import style0 from "./barcode.vue?vue&type=style&index=0&id=96bc6fda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bc6fda",
  null
  
)

export default component.exports